import type { ImageFormat } from '@belong/types';

export const cleanContentType = (rawValue: string): ImageFormat => {
  if (rawValue === 'image/svg+xml') {
    return 'svg';
  }

  return rawValue === 'image/png' ? 'png' : 'jpg';
};
